/* Le nove schermate, ancora come segnaposto.
 *
 * Ogni voce dichiara scopo ed endpoint: sono le due cose che chi la scriverà
 * dovrebbe ricostruire leggendo i controller, e che qui sono già decise. */

import { Segnaposto } from './Segnaposto';

/* Le due schermate dei backtest sono scritte: vivono in `pagine/backtest/` e
   da qui si ri-esportano soltanto, così il router non cambia. */
export { TuttiIBacktest } from './backtest/TuttiIBacktest';
export { DettaglioBacktest } from './backtest/DettaglioBacktest';
/* La schermata che mancava al disegno: le nove coprivano consultare,
   confrontare e mettere live, non creare. */
export { NuovoBacktest } from './backtest/NuovoBacktest';
/* Il confronto fra backtest: la schermata che risponde a «perche' uno e' meglio
   dell'altro», che e' la domanda che l'ordinamento della lista non risolve. */
export { ConfrontoBacktest } from './backtest/ConfrontoBacktest';

/* Le due schermate dei tradebot sono scritte: vivono in `pagine/tradebot/` e
   valgono le stesse regole — il router importa sempre da `../pagine`. */
export { ListaTradebot, DettaglioTradebot, NuovoTradebot } from './tradebot';

/* Dashboard: scritta, vive in `pagine/Dashboard.tsx`. Da qui si ri-esporta
   soltanto, così il router resta intatto. */
export { Dashboard } from './Dashboard';

/* Scritte, non più segnaposto. Restano esportate da qui perché è questo il
 * modulo che il router conosce: cambiare il router per una schermata pronta
 * avrebbe fatto toccare a ogni schermata un file di tutti. */
export { Gruppi } from './Gruppi';

export { Preferiti } from './Preferiti';

/* Wallet multi-catena: scritta, vive in `pagine/Wallet.tsx` con i suoi pezzi
   in `pagine/wallet/`. */
export { Wallet } from './Wallet';

/* Cassaforte: i wallet personali cifrati nel browser. E' l'altra tabella,
   `personal_wallet`, e per questo e' un'altra schermata: la distinzione sta
   scritta in testa a `pagine/Cassaforte.tsx`. */
export { Cassaforte } from './Cassaforte';

/* Le quattro schermate minori (accesso, account & exchange, dati storici,
   impostazioni) stanno sotto un'unica rotta, con la sezione nell'URL. */
export { Impostazioni } from './Impostazioni';

export function NonTrovata() {
  return (
    <Segnaposto
      titolo="Pagina non trovata"
      scopo="L'indirizzo non corrisponde a nessuna schermata."
      endpoint={[]}
    />
  );
}
